import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence } from 'framer-motion';
import { logVisitIfNotAdmin } from './utils/analytics';
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Import Firebase Auth functions

// Layout Components
import Layout from './components/layout/Layout';
import AdminLayout from './components/admin/AdminLayout';

// Public Pages
import Home from './pages/public/Home';
import About from './pages/public/About';
import Services from './pages/public/Services';
import Tools from './pages/public/Tools';
import Blog from './pages/public/Blog';
import BlogDetail from './pages/public/BlogDetail';
import Testimonials from './pages/public/Testimonials';
import Contact from './pages/public/Contact';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ManageBlog from './pages/admin/ManageBlog';
import ManageCategories from './pages/admin/ManageCategories';
import ManageSlides from './pages/admin/ManageSlides';
import ManageTestimonials from './pages/admin/ManageTestimonials';
import ManageContactMessages from './pages/admin/ManageContactMessages';

import ScroolToTop from "./components/common/ScroolToTop";

// Protected Route Component
import ProtectedRoute from './components/common/ProtectedRoute';

function App() {
  useEffect(() => {
    // Log visit only if user is not authenticated (not an admin)
    logVisitIfNotAdmin();
  }, []);

  return (
    <div className="App">
      <AnimatePresence>
      <ScroolToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/tools" element={<Layout><Tools /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
          <Route path="/testimonials" element={<Layout><Testimonials /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminLayout><AdminDashboard /></AdminLayout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/blog" 
            element={
              <ProtectedRoute>
                <AdminLayout><ManageBlog /></AdminLayout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/categories" 
            element={
              <ProtectedRoute>
                <AdminLayout><ManageCategories /></AdminLayout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/slides" 
            element={
              <ProtectedRoute>
                <AdminLayout><ManageSlides /></AdminLayout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/testimonials" 
            element={
              <ProtectedRoute>
                <AdminLayout><ManageTestimonials /></AdminLayout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/contact-messages" 
            element={
              <ProtectedRoute>
                <AdminLayout><ManageContactMessages /></AdminLayout>
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AnimatePresence>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;